import { ProductCardProps } from '../../home/types/types';

/**
 * Get products
 * @param {string} categoryId - Category ID
 * @param {string} genderId
 * @param {number} page - Page number
 * @param {number} items_per_page - Items per page
 * @param {number} brandId - Brand ID
 * @returns {Promise<ProductCardProps[]>} - Array of products
 */
export const getProducts = async ({
  categoryId,
  genderId,
  page,
  items_per_page,
  brandId,
  vendorId,
}: {
  categoryId?: string;
  genderId?: string;
  page?: number;
  items_per_page?: number;
  brandId?: number;
  vendorId?: number;
}): Promise<{ products: ProductCardProps[]; hasNext: boolean }> => {
  const url = new URL('/wp-json/wp/v2/GetProducts', window.location.origin);

  if (categoryId) url.searchParams.set('category_id', categoryId);
  if (genderId) url.searchParams.set('gender_id', genderId);
  if (page) url.searchParams.set('page', page.toString());
  if (items_per_page) url.searchParams.set('items_per_page', items_per_page.toString());
  if (brandId) url.searchParams.set('brand_id', brandId.toString());
  if (vendorId) url.searchParams.set('vendor_id', vendorId.toString());

  const sortByFromUrl = getUrlParameter('sortBy');
  if (sortByFromUrl) url.searchParams.set('sort_by', sortByFromUrl);

  const sortOrderFromUrl = getUrlParameter('sortOrder');
  if (sortOrderFromUrl) url.searchParams.set('sort_order', sortOrderFromUrl);

  const categorySlugFromUrl = getUrlParameter('category');
  if (categorySlugFromUrl) url.searchParams.set('category_slug', categorySlugFromUrl);

  const attributesFromUrl = window.location.search.match(/attributes\[[^\]]+\]=[^&]+/g);
  if (attributesFromUrl) {
    attributesFromUrl.forEach((attr) => {
      const [key, value] = attr.split('=');
      url.searchParams.append(key, value);
    });
  }

  const genderFromUrl = getUrlParameter('gender_id');
  if (genderFromUrl) url.searchParams.set('gender_id', genderFromUrl);

  // const { data } = await getFromCrm<{ products: ProductCardProps[] }>(
  //   "/ecommerce/products",
  //   url.searchParams
  // );

  const response = await fetch(url);
  const json = await response.json();

  return json;
};

/**
 * Get URL parameter
 * @param {string} param - Parameter name
 * @returns {string | undefined} - Parameter value
 */
const getUrlParameter = (param: string): string | undefined => {
  const value = window.location.search.split(`${param}=`)[1];
  return value ? value.split('&')[0] : undefined;
};
